const theme = {
  breakpoints: {
    s: "only screen and (max-width: 55rem)",
    m: "only screen and (max-width: 62rem)",
  },
}

export default theme
